"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qrcode = __importStar(require("qrcode"));
var styles_1 = __importDefault(require("./styles"));
var BrowserTransport = /** @class */ (function () {
    function BrowserTransport(options) {
        if (options === void 0) { options = {}; }
        this.options = options;
        this.classPrefix = options.classPrefix || 'anchor-link';
        this.injectStyles = !(options.injectStyles === false);
    }
    BrowserTransport.prototype.setupElements = function () {
        var _this = this;
        if (this.injectStyles && !this.styleEl) {
            this.styleEl = document.createElement('style');
            this.styleEl.type = 'text/css';
            var css = styles_1.default.replace(/%prefix%/g, this.classPrefix);
            this.styleEl.appendChild(document.createTextNode(css));
            document.head.appendChild(this.styleEl);
        }
        if (!this.containerEl) {
            this.containerEl = this.createEl();
            this.containerEl.className = this.classPrefix;
            this.containerEl.style.display = 'hidden';
            this.containerEl.onclick = function (event) {
                if (event.target === _this.containerEl) {
                    event.stopPropagation();
                    _this.hide();
                    if (_this.activeCancel) {
                        _this.activeRequest = undefined;
                        _this.activeCancel('Modal closed');
                    }
                }
            };
            document.body.appendChild(this.containerEl);
        }
        if (!this.requestEl) {
            this.requestEl = this.createEl({ class: 'request' });
            this.containerEl.appendChild(this.requestEl);
        }
    };
    BrowserTransport.prototype.createEl = function (attrs) {
        var e_1, _a;
        if (!attrs)
            attrs = {};
        var el = document.createElement(attrs.tag || 'div');
        if (attrs) {
            try {
                for (var _b = __values(Object.keys(attrs)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var attr = _c.value;
                    var value = attrs[attr];
                    switch (attr) {
                        case 'tag':
                            break;
                        case 'text':
                            el.appendChild(document.createTextNode(value));
                            break;
                        case 'class':
                            el.className = this.classPrefix + "-" + value;
                            break;
                        default:
                            el.setAttribute(attr, value);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return el;
    };
    BrowserTransport.prototype.hide = function () {
        if (this.containerEl) {
            this.containerEl.classList.remove(this.classPrefix + "-active");
        }
        if (this.countdownTimer) {
            clearTimeout(this.countdownTimer);
            this.countdownTimer = undefined;
        }
    };
    BrowserTransport.prototype.show = function () {
        if (this.containerEl) {
            this.containerEl.classList.add(this.classPrefix + "-active");
        }
    };
    BrowserTransport.prototype.displayRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var uri, isIdentity, title, subtitle, qrEl, _a, linkEl, infoEl, infoTitle, infoSubtitle, actionEl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setupElements();
                        uri = request.encode(true, false);
                        isIdentity = request.isIdentity();
                        title = isIdentity ? 'Log In' : 'Sign';
                        subtitle = 'Scan this QR code in Anchor to continue';
                        qrEl = this.createEl({ class: 'qr' });
                        _a = qrEl;
                        return [4 /*yield*/, qrcode.toString(uri, {
                                margin: 0,
                                errorCorrectionLevel: 'L',
                            })];
                    case 1:
                        _a.innerHTML = _b.sent();
                        linkEl = this.createEl({ class: 'uri' });
                        linkEl.appendChild(this.createEl({
                            tag: 'a',
                            href: uri,
                            text: 'Open in local wallet',
                        }));
                        infoEl = this.createEl({ class: 'info' });
                        infoTitle = this.createEl({ class: 'title', tag: 'span', text: title });
                        infoSubtitle = this.createEl({ class: 'subtitle', tag: 'span', text: subtitle });
                        infoEl.appendChild(infoTitle);
                        infoEl.appendChild(infoSubtitle);
                        actionEl = this.createEl({ class: 'actions' });
                        actionEl.appendChild(qrEl);
                        actionEl.appendChild(linkEl);
                        emptyElement(this.requestEl);
                        this.requestEl.appendChild(infoEl);
                        this.requestEl.appendChild(actionEl);
                        this.show();
                        return [2 /*return*/];
                }
            });
        });
    };
    BrowserTransport.prototype.onRequest = function (request, cancel) {
        this.activeRequest = request;
        this.activeCancel = cancel;
        this.displayRequest(request).catch(cancel);
    };
    BrowserTransport.prototype.onSessionRequest = function (session, request, timeout, device, cancel) {
        this.activeRequest = request;
        this.activeCancel = cancel;
        this.setupElements();
        var start = Date.now();
        var countdownEl = this.createEl({ class: 'session-countdown' });
        var updateCountdown = function () {
            var timeLeft = timeout + start - Date.now();
            countdownEl.textContent = new Date(timeLeft).toISOString().substr(14, 5);
        };
        this.countdownTimer = setInterval(updateCountdown, 300);
        updateCountdown();
        var infoEl = this.createEl({ class: 'session-info' });
        infoEl.appendChild(document.createTextNode('Please open Anchor on '));
        infoEl.appendChild(this.createEl({ tag: 'span', class: 'device', text: device }));
        infoEl.appendChild(document.createTextNode(' to review and sign the transaction.'));
        emptyElement(this.requestEl);
        this.requestEl.appendChild(infoEl);
        this.requestEl.appendChild(countdownEl);
        this.show();
    };
    BrowserTransport.prototype.onSuccess = function (request) {
        if (request === this.activeRequest) {
            this.hide();
        }
    };
    BrowserTransport.prototype.onFailure = function (request, error) {
        if (request === this.activeRequest) {
            this.setupElements();
            var errorEl = this.createEl({ class: 'error' });
            errorEl.innerHTML = "\n                Transaction error: " + (error.message || String(error)) + "\n            ";
            emptyElement(this.requestEl);
            this.requestEl.appendChild(errorEl);
            this.show();
        }
    };
    return BrowserTransport;
}());
exports.default = BrowserTransport;
function emptyElement(el) {
    while (el.firstChild) {
        el.removeChild(el.firstChild);
    }
}
//# sourceMappingURL=index.js.map